import { render } from "./billing-history-transaction.vue?vue&type=template&id=4b1b19c5"
import script from "./billing-history-transaction.vue?vue&type=script&lang=js"
export * from "./billing-history-transaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__